<div class="container mt-3">
    @if (view$ | async; as view) {
        <div class="d-flex justify-content-between align-items-end my-3">
            <h1 class="m-0">
                {{ view.agent.agentName }}
            </h1>
            @if (
                (view.agent.consumptionToMonitor !== 'INDIVIDUALCONSUMPTION' &&
                    view.agent.showConsumptionForMeters) ||
                (view.agent.consumptionToMonitor === 'INDIVIDUALCONSUMPTION' &&
                    view.agentResult.isAgentCriteriaFulfilled)
            ) {
                <button
                    type="button"
                    class="btn btn-outline-primary"
                    [disabled]="exportLoading()"
                    (click)="downloadFile(view.buildingNo, view.agent)">
                    {{ 'actions_export' | translate: 'online' : 'systems' }}
                </button>
            }
        </div>
        <div class="row">
            <div class="col-sm-12 col-lg-6 pb-3">
                <div class="card mb-3">
                    <div class="card-title tile-header me-0">
                        <h3 class="d-inline-block w-100 ms-3 me-0 pt-2">
                            {{ 'consumption-agents_result-of-investigation' | translate }}
                        </h3>
                    </div>
                    <div class="card-body">
                        @if (resultText$ | async; as message) {
                            {{ message }}
                        } @else {
                            <app-load></app-load>
                        }
                    </div>
                </div>
            </div>
            <div class="col-sm-12 col-lg-6 pb-3">
                <app-consumption-card
                    [resultView]="true"
                    [consumptionAgent]="view.agent"
                    [buildingNo]="view.buildingNo" />
            </div>
        </div>
        @if (
            view.agent.showConsumptionForMeters ||
            view.agent.consumptionToMonitor === 'INDIVIDUALCONSUMPTION'
        ) {
            <div class="card mb-3">
                <div class="card-title tile-header">
                    <h3 class="d-inline-block w-100 ms-3 me-0 pt-2">
                        {{ 'consumption-agents_meters-in-report' | translate }}
                    </h3>
                </div>
                <app-consumption-agent-result-table
                    [consumptionAgent]="view.agent"
                    [results]="view.agentResult"></app-consumption-agent-result-table>
            </div>
        }
    } @else {
        <app-load></app-load>
    }
</div>
